// Import 3rd-party dependencies
import { Directive, OnChanges, Input, ChangeDetectorRef, ElementRef, Renderer2, OnDestroy, OnInit } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import { INPUT_CLEAR_DIRECTIVE_CONSTS } from '@app/config/constants';

@Directive({
  selector: '[appClearInput]',
  exportAs: 'appClearInput'
})
export class InputClearDirective implements OnInit, OnChanges, OnDestroy {
  private subs: SubSink;
  @Input('appClearInput') inputFieldValue: string;
  clearIcon: HTMLElement;
  consts = INPUT_CLEAR_DIRECTIVE_CONSTS;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subs = new SubSink();
    this.clearIcon = this.renderer.createElement('a') as HTMLElement;
  }

  ngOnChanges(): void {
    this.changeDetectorRef.detectChanges();

    // show icon by default if text field has value
    this.showClearIcon();
    if (this.inputFieldValue.length > 0) {
      this.renderer.addClass(this.clearIcon, 'show');
    }

    // show/hide icon on text field value changes
    this.subs.sink = fromEvent(this.elementRef.nativeElement, 'keyup')
      .pipe(debounceTime(this.consts.EVENT_DEBOUNCE_TIME))
      .subscribe(() => {
        if (!this.inputFieldValue) {
          this.renderer.removeClass(this.clearIcon, 'show');
        } else {
          this.renderer.addClass(this.clearIcon, 'show');
        }
      });
  }

  ngOnDestroy(): void {
    this.clearIcon.removeEventListener('click', null);
    this.subs.unsubscribe();
  }

  // create clear icon
  showClearIcon(): void {
    const target = this.elementRef.nativeElement as HTMLElement;
    const parentElement = (this.elementRef.nativeElement as HTMLElement).parentNode;
    this.renderer.setProperty(this.clearIcon, 'innerHTML', '&times;');
    this.renderer.addClass(this.clearIcon, 'clear-input');
    this.renderer.appendChild(parentElement, this.clearIcon);

    this.subs.sink = fromEvent(this.clearIcon, 'click')
      .pipe(debounceTime(this.consts.EVENT_DEBOUNCE_TIME))
      .subscribe(() => {
        target.closest('form').reset();
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', '');
        this.renderer.removeClass(this.clearIcon, 'show');
      });
  }
}
